import React from 'react'

const ChatMessageContext = React.createContext()

export default ChatMessageContext
